import F from "ramda/es/F";
import isNil from "ramda/es/isNil";
import { LOGOUT_URL_CONTEXT } from '../../constants';
// Token was revoked or is invalid on API Management -> redirect page to /logout on Bifrost
// https://confluence.cpas.cz/x/RMATAQ
export default ((beforeLogout)=>({ failure, frontendUrl, customLogoutResolver = F })=>async (dispatch)=>{
            if (customLogoutResolver(failure) || failure.status === 401 && !isNil(frontendUrl) && failure.parsedContent && (failure.parsedContent.status === '401.4' || failure.parsedContent.status === '401.6')) {
                if (beforeLogout) {
                    await dispatch(beforeLogout);
                }
                window.location.assign(`${frontendUrl}${LOGOUT_URL_CONTEXT}`);
            }
            return Promise.resolve();
        });
